import {TextField, TextFieldProps} from '@mui/material'
import './MuiTextField.scss'

export const MuiTextField = (props: TextFieldProps) => {
  const {className, ...restProps} = props

  const mergedClassName = className ? `custom-text-field   ${className}` : 'custom-text-field'

  return <TextField size="small" {...restProps} className={mergedClassName} />
}
